<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.searchKey"  placeholder="应用包名/应用名称" />
      <el-input v-model="tableParams.appId"  placeholder="应用编号" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="handleAdd()" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <span v-if="v.field === 'isEnable'">{{ scope.row.isEnable  === 0 ? '已审核' : '未审核' }}</span>
              <span v-else-if="v.field === 'appType'">{{ appTypeMap[scope.row.appType] || '-' }}</span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="100">
            <template v-slot="scope" align="center">
              <el-button @click="handleUpdate(scope.row)" type="primary" size="mini">编辑</el-button>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>

    <m-form @submit="toQuery" ref="form" title="应用 " />

  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import mForm from './form'
import initTableMixin from '@/mixins/initTable'
import { appTypeMap } from '@/const/app-type'

export default {
  name: 'mediaApp',
  components: {
    TableColumn,
    mForm
  },
  mixins: [initTableMixin],
  data () {
    return {
      appTypeMap,
      columns: [
        { field: 'appId', title: '应用编号' },
        { field: 'appName', title: '应用名称' },
        { field: 'appBundle', title: '应用包名' },
        { field: 'appType', title: '应用类型' },
        { field: 'isEnable', title: '应用审核状态' },
        { field: 'createTime', title: '创建时间' }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/app/channel/list'
      return true
    },
    handleAdd () {
      this.$refs.form.show()
    },
    handleUpdate (row) {
      this.$refs.form.show(row)
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}
.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}
</style>
